const computedTitle = (title) => {
    return title ? { title } : undefined;
};
const computedPlaybackId = (muxPlaybackId, playbackId) => {
    if (!(muxPlaybackId || playbackId))
        return undefined;
    return { playbackId: `${muxPlaybackId || playbackId}` };
};
const computedStyle = (width, height) => {
    if (!(width && height))
        return undefined;
    return {
        style: {
            aspectRatio: `${width} / ${height}`,
        },
    };
};
const computedPlaceholder = (blurUpThumb) => {
    return blurUpThumb ? { placeholder: blurUpThumb } : undefined;
};
export const useVideoPlayer = ({ data, }) => {
    const { title, width, height, playbackId, muxPlaybackId, blurUpThumb } = data || {};
    if (data === undefined)
        return {};
    return Object.assign(Object.assign(Object.assign(Object.assign({}, (computedTitle(title) || {})), (computedPlaybackId(muxPlaybackId, playbackId) || {})), (computedStyle(width, height) || {})), (computedPlaceholder(blurUpThumb) || {}));
};
//# sourceMappingURL=index.js.map